import axios from "axios";
import Cookies from "js-cookie";

type ResponseType = { status: number; result?: any; errors?: any[] };

async function connection(
  url: string,
  data: Object = {}
): Promise<ResponseType> {
  let formData;
  if (data instanceof FormData) {
    formData = data;
  } else {
    formData = new FormData();
    Object.keys(data).forEach((value) => {
      formData.append(value, data[value]);
    });
  }
  let usertoken = Cookies.get("token");

  formData.append("token", usertoken ? usertoken : "-1");

  let res: ResponseType = await axios
    .post(`http://marketgroup.tatdemo.ir/${url}`, formData)
    .then((res) => res.data)
    .catch((error) => error);
  return res;
}

export { connection };
